export const byteToMb = (size: number): string => {
  const mb = size / (1024 * 1024);
  const roundMb = Math.round(mb * 100) / 100;
  return roundMb + "Mb";
};
